import React from 'react';
import { useThemeContext } from '../../contexts';

type IconProps = {
  iconWidth?: number;
  iconHeight?: number;
};

/**
 * CardReceiveIcon is a component that displays a card receive icon.
 *
 * @param {IconProps} props
 * @return {React.FC}
 */
const CardReceiveIcon: React.FC<IconProps> = (props) => {
  const { theme } = useThemeContext();
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      width={props.iconWidth}
      height={props.iconHeight}
      xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M2 8.5H14.5"
          stroke={theme.primary}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"></path>{' '}
        <path
          d="M6 16.5H8"
          stroke={theme.primary}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"></path>{' '}
        <path
          d="M10.5 16.5H14.5"
          stroke={theme.primary}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"></path>{' '}
        <path
          d="M22 14.03V16.11C22 19.62 21.11 20.5 17.56 20.5H6.44C2.89 20.5 2 19.62 2 16.11V7.89C2 4.38 2.89 3.5 6.44 3.5H14.5"
          stroke={theme.primary}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"></path>{' '}
        <g>
          {' '}
          <path
            d="M20 3.5V9.5L22 7.5"
            stroke={theme.secondary}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"></path>{' '}
          <path
            d="M20 9.5L18 7.5"
            stroke={theme.secondary}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"></path>{' '}
        </g>{' '}
      </g>
    </svg>
  );
};

export default CardReceiveIcon;
